import {
	observer
} from 'mobx-react';
import {
	WeaTableNew,
} from 'comsMobx';
const WeaTable = WeaTableNew.WeaTable;

@observer
export default class Table extends React.Component {
	render() {
		const {
			tableProps,
			tableStore
		} = this.props;
		
		return (
			<WeaTable ecId={`${this && this.props && this.props.ecId || ''}_WeaTable@h6159r`} 
				{...tableProps}
				comsWeaTableStore={tableStore}
			/>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/public/coms/Table.js